export default "__VITE_ASSET__acc616c9__"